import { useEffect, useState } from 'react';
import { api } from '../api';

/* =====================================================================
   Domiciliar el cobro a una tarjeta · carril ops (19 sep 2026, E11)
   =====================================================================
   Nace APAGADA. Clip sí ofrece cobro recurrente (el cliente domicilia su
   tarjeta en un enlace de Clip; Clip la guarda), pero falta la
   referencia de su API de Suscripciones y un plan creado en Clip: hasta
   entonces el botón se ve, está apagado y dice por qué (regla 8 de
   USUARIO CERO). Nada se simula: TEGO nunca guarda números de tarjeta.
   ===================================================================== */
export default function Domiciliacion() {
  const [d, setD] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/ops/domiciliacion').then((r) => { if (vivo) setD(r); }).catch(() => { if (vivo) setD({ activa: false, hoy: 'No se pudo leer el estado de la domiciliación.' }); });
    return () => { vivo = false; };
  }, []);
  if (!d) return null;
  return (
    <div className="rounded-lg border border-gray-200 p-3 space-y-2">
      <p className="text-sm font-semibold text-gray-800">Domiciliar el cobro a mi tarjeta</p>
      <div className="flex flex-wrap items-center gap-2">
        {/* LOS TRES VAN APAGADOS Y DICEN POR QUÉ · TODO-SIRVE F5, 30 sep
            2026. La guarda de fachadas del cliente (guardasDeFachada.test.js)
            cazó que «Activar» se encendía con TEGO_DOMICILIACION pero no
            tenía acción —el flujo con Clip todavía no existe—: un botón que
            se ve, se puede pulsar y no hace nada. Y los otros dos estaban
            grises sin decir por qué. Ahora los tres apuntan al párrafo de
            abajo, que dice qué hay y qué falta. */}
        <button type="button" disabled aria-describedby="domiciliacion-motivo"
                title={d.activa ? 'El paso de activarla desde TEGO se construye con la referencia de Clip; hoy se domicilia en el enlace de Clip.' : d.hoy}
                className="px-3 py-1.5 rounded-lg border border-gray-300 text-sm bg-gray-50 text-gray-500 disabled:cursor-not-allowed">
          Activar la domiciliación
        </button>
        <button type="button" disabled aria-describedby="domiciliacion-motivo" className="px-3 py-1.5 rounded-lg border border-gray-300 text-sm bg-gray-50 text-gray-500 cursor-not-allowed">Cambiar tarjeta</button>
        <button type="button" disabled aria-describedby="domiciliacion-motivo" className="px-3 py-1.5 rounded-lg border border-gray-300 text-sm bg-gray-50 text-gray-500 cursor-not-allowed">Cancelar</button>
      </div>
      <p id="domiciliacion-motivo" className="text-xs text-gray-600">{d.activa ? d.como : `Apagada: ${d.hoy}`}</p>
      {!d.activa && d.que_hace_falta && (
        <details className="text-xs text-gray-600">
          <summary className="cursor-pointer">Qué hace falta para encenderla</summary>
          <ul className="list-disc pl-5 mt-1 space-y-0.5">{d.que_hace_falta.map((q) => <li key={q}>{q}</li>)}</ul>
          <p className="mt-1">{d.nunca}</p>
        </details>
      )}
    </div>
  );
}
